type Props = {
  points: number[];
  color?: string;
};

export function Sparkline({ points, color = "var(--manager-accent)" }: Props) {
  if (!points.length) {
    return <div className="h-10 rounded bg-slate-100" />;
  }
  const max = Math.max(...points);
  const min = Math.min(...points);
  const span = Math.max(1, max - min);
  const width = 120;
  const height = 40;
  const coordinates = points
    .map((value, index) => {
      const x = (index / Math.max(1, points.length - 1)) * width;
      const y = height - ((value - min) / span) * (height - 4) - 2;
      return `${x},${y}`;
    })
    .join(" ");

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label="trend sparkline">
      <polyline fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" points={coordinates} />
    </svg>
  );
}
